import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";

export default function Conceptos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "Descripción", dataKey: "descripcion" },
    { title: "ID Presupuesto", dataKey: "id_presupuesto" },
    { title: "Habilitado", dataKey: "habilitado" },
  ];

  const [concepto, guardarConcepto] = useState(null);
  const [visible, setVisible] = useState(false);
  const [detalle, guardarDetalle] = useState(null);
  const [fecha, guardarFecha] = useState(null);
  const toast = useRef(null);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    conceptos,
    tiposGastos,
    obtenerConceptos,
    obtenerTiposGastos,
    obtenerAcceso,
    agregarConcepto,
    actualizarConcepto,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Conceptos" });
    }
  }, [state]);

  useEffect(() => {
    obtenerConceptos();
    obtenerTiposGastos();
  }, []);

  const editClick = (e) => {
    if (selectedRow) {
      guardarConcepto(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un concepto.",
        life: 3000,
      });
    }
  };

  const addClick = (e) => {
    //props.history.push(`/concepto/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarConcepto({
      habilitado: true,
      arendir: false,
    });
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar
    if (
      !concepto ||
      concepto.nombre === undefined ||
      concepto.nombre === null ||
      concepto.nombre.trim() === ""
    ) {
      mensajeAlerta("Conceptos", "Nombre es necesario !.", "error");
      return;
    }

    if (
      concepto &&
      concepto.id_presupuesto &&
      concepto.id_presupuesto !== "0" &&
      (!concepto.id_tipogasto || concepto.id_tipogasto === "")
    ) {
      mensajeAlerta("Conceptos", "Tipo de gasto es necesario !.", "error");
      return;
    }

    // Llamar al context
    if (selectedRow) {
      actualizarConcepto({ concepto });
    } else {
      agregarConcepto({ concepto });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerConceptos();
      obtenerTiposGastos();
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Conceptos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, conceptos);
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(conceptos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "conceptos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        />
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Conceptos"></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Concepto"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(tiposGastos);
  //console.log(conceptos);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {conceptos ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ align: "center", margin: "1em" }}
              >
                <Button
                  icon="pi pi-plus"
                  tooltip="Agregar"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "0em" }}
                  onClick={addClick}
                />
                <Button
                  icon="pi pi-pencil"
                  tooltip="Editar"
                  className="p-button-rounded p-button-danger"
                  style={{ marginLeft: "1em" }}
                  onClick={editClick}
                />
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <Tooltip
                      target=".export-buttons>button"
                      position="bottom"
                    />
                    <DataTable
                      value={conceptos}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={header}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "1vw" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={500}
                      rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        //body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="nombre"
                        header="Nombre"
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="id_presupuesto"
                        header="ID Presupuesto"
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="tiposgastos.nombre"
                        header="Tipo Gasto"
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="habilitado"
                        header="Habilitado"
                        body={habilitadoTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
              <Dialog
                header={renderHeader()}
                visible={visible}
                closable={false}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  <Grid item xs={12} md={2}>
                    <TextField
                      value={concepto ? concepto.id : null}
                      required
                      variant="standard"
                      id="id"
                      label="ID"
                      fullWidth
                      disabled={selectedRow}
                      onChange={(e) =>
                        guardarConcepto({
                          ...concepto,
                          id: e.target.value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <TextField
                      value={concepto ? concepto.nombre : null}
                      required
                      variant="standard"
                      id="nombre"
                      label="Nombre"
                      fullWidth
                      onChange={(e) =>
                        guardarConcepto({
                          ...concepto,
                          nombre: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={4}>
                    <TextField
                      value={concepto ? concepto.id_presupuesto : null}
                      required
                      variant="standard"
                      id="id_presupuesto"
                      label="ID Presupuesto"
                      fullWidth
                      onChange={(e) =>
                        guardarConcepto({
                          ...concepto,
                          id_presupuesto: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <Autocomplete
                      id="idTipoGasto"
                      //size={"small"}
                      fullWidth
                      noOptionsText={"No hay opciones"}
                      options={tiposGastos ? tiposGastos : null}
                      defaultValue={
                        selectedRow && tiposGastos && tiposGastos.length > 0
                          ? tiposGastos[
                              tiposGastos.findIndex(
                                (item) => item.id === selectedRow.id_tipogasto,
                              )
                            ]
                          : null
                      }
                      getOptionLabel={(option) => option.nombre}
                      openOnFocus={true}
                      disablePortal
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tipo Gasto"
                          variant="standard"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          guardarConcepto({
                            ...concepto,
                            id_tipogasto: value.id,
                          });
                        } else {
                          guardarConcepto({
                            ...concepto,
                            id_tipogasto: null,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ paddingLeft: 0, marginTop: "1.5vw" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={concepto ? concepto.habilitado : null}
                          style={{ marginLeft: "1vw" }}
                          onChange={(e) =>
                            guardarConcepto({
                              ...concepto,
                              habilitado: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Habilitado"
                      labelPlacement="start"
                      style={{ paddingLeft: ".7vw" }}
                    />
                  </Grid>
                </Grid>
              </Dialog>
            </Fragment>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
